// AUTO-GENERATED GraphQL Builder for EventSession
import * as Builders from '../';
export class EventSessionBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  code(){ return this.add('code'); }
  label(){ return this.add('label'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  blockedDateList(b?:(q:Builders.BlockedDateBuilder)=>void){
    if(this.depth>=5||this.v.has('blockedDateList'))return this;
    this.v.add('blockedDateList');
    const n=new Builders.BlockedDateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`blockedDateList { ${inner} }`);
    return this;
  }

  bookingList(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingList'))return this;
    this.v.add('bookingList');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingList { ${inner} }`);
    return this;
  }

  bookingChangeProposalList(b?:(q:Builders.BookingChangeProposalBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingChangeProposalList'))return this;
    this.v.add('bookingChangeProposalList');
    const n=new Builders.BookingChangeProposalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingChangeProposalList { ${inner} }`);
    return this;
  }

  bookingPackageList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageList'))return this;
    this.v.add('bookingPackageList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  offeringSessionList(b?:(q:Builders.OfferingSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringSessionList'))return this;
    this.v.add('offeringSessionList');
    const n=new Builders.OfferingSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSessionList { ${inner} }`);
    return this;
  }

  packageItemList(b?:(q:Builders.PackageItemBuilder)=>void){
    if(this.depth>=5||this.v.has('packageItemList'))return this;
    this.v.add('packageItemList');
    const n=new Builders.PackageItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageItemList { ${inner} }`);
    return this;
  }

  resaleList(b?:(q:Builders.ResaleBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleList'))return this;
    this.v.add('resaleList');
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  resaleTermList(b?:(q:Builders.ResaleTermBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleTermList'))return this;
    this.v.add('resaleTermList');
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }

  waitlistList(b?:(q:Builders.WaitlistBuilder)=>void){
    if(this.depth>=5||this.v.has('waitlistList'))return this;
    this.v.add('waitlistList');
    const n=new Builders.WaitlistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`waitlistList { ${inner} }`);
    return this;
  }

  weddingCardList(b?:(q:Builders.WeddingCardBuilder)=>void){
    if(this.depth>=5||this.v.has('weddingCardList'))return this;
    this.v.add('weddingCardList');
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCardList { ${inner} }`);
    return this;
  }

  reverseBlockedDate(b?:(q:Builders.BlockedDateBuilder)=>void){
    const n=new Builders.BlockedDateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`blockedDateList { ${inner} }`);
    return this;
  }

  reverseBookingChangeProposal(b?:(q:Builders.BookingChangeProposalBuilder)=>void){
    const n=new Builders.BookingChangeProposalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingChangeProposalList { ${inner} }`);
    return this;
  }

  reverseBookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  reverseBooking(b?:(q:Builders.BookingBuilder)=>void){
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingList { ${inner} }`);
    return this;
  }

  reverseOfferingSession(b?:(q:Builders.OfferingSessionBuilder)=>void){
    const n=new Builders.OfferingSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSessionList { ${inner} }`);
    return this;
  }

  reverseResale(b?:(q:Builders.ResaleBuilder)=>void){
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  reverseResaleTerm(b?:(q:Builders.ResaleTermBuilder)=>void){
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }

  reverseWaitlist(b?:(q:Builders.WaitlistBuilder)=>void){
    const n=new Builders.WaitlistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`waitlistList { ${inner} }`);
    return this;
  }

  reverseWeddingCard(b?:(q:Builders.WeddingCardBuilder)=>void){
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCardList { ${inner} }`);
    return this;
  }
}
